import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles(theme => ({
  releaseNotes: {
    marginBottom: '70px',
  },
}));
